import { render, staticRenderFns } from "./UnifiedSearch.vue?vue&type=template&id=613fe700&scoped=true&"
import script from "./UnifiedSearch.vue?vue&type=script&lang=ts&"
export * from "./UnifiedSearch.vue?vue&type=script&lang=ts&"
import style0 from "./UnifiedSearch.vue?vue&type=style&index=0&id=613fe700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613fe700",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VIcon,VRow,VTextField})
